export default function pruneObject(obj = {}) {
  const keysStack = [];
  const visited = {
    nodes: [],
    keys: [],
  };

  const visitNode = (node, key = '~') => {
    if (node === null || node === undefined || node === '') {
      return undefined;
    }

    if (node === Object(node) && !Object.keys(node).length) {
      return undefined;
    }

    if (Array.isArray(node) && !node.length) {
      return undefined;
    }

    if (typeof node === 'function') {
      return undefined;
    }

    const needlePos = visited.nodes.indexOf(node);
    if (needlePos !== -1) {
      return `[Deduped from ${visited.keys[needlePos]}]`;
    }

    if (!Array.isArray(node) && node !== Object(node)) {
      return node;
    }

    if (node instanceof HTMLElement) {
      return node.toString();
    }

    keysStack.push(key);

    visited.nodes.push(node);
    visited.keys.push(keysStack.join('.'));

    if (Array.isArray(node)) {
      const result = node.map(visitNode).filter(((v) => v !== undefined));

      keysStack.pop();

      return result;
    }

    const result = Object.entries(node).reduce((res, [k, v]) => {
      const value = visitNode(v, k);
      if (value !== undefined) {
        res[k] = value;
      }

      return res;
    }, {});

    keysStack.pop();

    return result;
  };


  return visitNode(obj) || {};
}
